// extracted by mini-css-extract-plugin
export default {"phone":"Styles-module__phone--884d","phoneCountry":"Styles-module__phoneCountry--74a7"};